import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { GridComponent, GridDataResult } from '@progress/kendo-angular-grid';
import { orderBy, SortDescriptor, State } from '@progress/kendo-data-query';
import { Globals } from 'src/app/common/globals';
import { CommonService } from 'src/app/common/services/common.service';
import { ProfileService } from '../profile.service';
import { PaymentService } from 'src/app/app-application/payment/payment.services';

@Component({
    selector: 'app-payment-history',
    templateUrl: './payment-history.component.html',
    standalone: false
})
export class PaymentHistoryComponent implements OnInit {
  constructor(
    public globals: Globals,
    public commonService: CommonService,
    public profileService: ProfileService,
    public paymentService: PaymentService
  ) { }

  @Input() userId: string = this.globals.authData.id;
  @ViewChild('kendoGrid') grid!: GridComponent;

  gridSearchPlaceholder: string = 'Search with Credential Name or Type';
  data: any = [];
  filterData: any = [];
  searchText: string = '';
  gridState: State = {
    skip: 0,
    take: this.globals.defaultPageSize,
    sort: [
      {
        field: 'updated_at',
        dir: 'desc',
      },
    ],
  };
  transaction_id: any;
  PaymentHistoryInfo: any;
  gridData: GridDataResult = { data: [], total: 0 };

  ngOnInit(): void {
    this.getPaymentHistory();
  }

  getPaymentHistory() {
    this.commonService.showLoader();
    this.profileService.getPaymentHistory(this.userId).then(
      (data: any) => {
        this.PaymentHistoryInfo = data.data;

        this.PaymentHistoryInfo.forEach((element: any) => {
          element.credentialName =
            element.credential_name +
            ' (' +
            element.credential_short_name +
            ')';
          element.typeLabel = this.typeMap[element.type] || '';
        });

        this.gridData = {
          data: this.PaymentHistoryInfo.slice(
            this.gridState.skip,
            this.gridState.skip! + this.gridState.take!
          ),
          total: this.PaymentHistoryInfo.length,
        };
        this.filterData = this.PaymentHistoryInfo;
        this.commonService.hideLoader();
      },
      (error) => { }
    );
  }

  async viewReceipt(id: any): Promise<void> {
    this.commonService.showLoader();
    this.transaction_id = id;
    try {
      const entity = {
        payment_intent_id: this.transaction_id,
      };
      const { data } = await this.paymentService.getReceiptUrl(entity);
      const { receipt_url } = data;
      if (receipt_url) {
        window.open(receipt_url, '_blank');
      }
    } finally {
      this.commonService.hideLoader();
    }
  }

  // Grid
  stateChange(state: State) {
    this.gridState.sort = state.sort;
    this.gridState.skip = state.skip;
    this.gridState.take = state.take;
    this.applyPagination();
  }

  sortChange(sortData: SortDescriptor[]) {
    if (this.gridData?.data.length) {
      this.gridData.data = orderBy(this.gridData.data, sortData);
      this.gridState.skip = 0;
    }
  }

  setPaginationCookie() {
    const entity = {
      state: this.gridState,
      search: this.searchText.trim(),
    };
  }

  gridSearchChange: (...args: any[]) => void = this.globals.debounce(() => {
    const isCleared = !this.searchText || this.searchText.trim() === '';
    if (isCleared) {
      const allowed = [5, 10, 20];
      const take = this.gridState.take ?? 0;

      if (!allowed.includes(take)) {
        this.gridState = { ...this.gridState, take: 5, skip: 0 };
      }
    }

    this.onSearchChange();
  }, 500);

  typeMap: any = {
    app_transaction: 'Application Fees',
    emeritus: 'Emeritus Fees',
    extension: 'Extension Fees',
    exam_retake: 'Exam Retake Fees',
  };

  onSearchChange() {
    this.gridState.skip = 0;
    this.gridState.take =
      this.gridState.take === this.gridData.total && this.searchText === ''
        ? this.filterData.length
        : this.gridState.take;

    var lowerSearchText = this.searchText.toLowerCase().trim();
    const filterdData = this.filterData.filter((item: any) => {
      return (
        item.credentialName?.toLowerCase()?.includes(lowerSearchText) ||
        item.typeLabel?.toLowerCase()?.includes(lowerSearchText)
      );
    });

    this.gridData = {
      data: filterdData,
      total: filterdData.length,
    };
  }

  applyPagination() {
    this.gridData = {
      data:
        this.PaymentHistoryInfo?.slice(
          this.gridState?.skip || 0,
          (this.gridState?.skip || 0) + (this.gridState?.take || 10)
        ) || [],
      total: this.PaymentHistoryInfo?.length || 0,
    };
  }
}
